import type { QueryClient } from "@tanstack/react-query";
import { type LoaderFunctionArgs, defer } from "react-router-dom";
import { getCompaniesOptions } from "../../../services/organtization/company/get-companies";

export const buildClientsLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    if (!params.organizationId) throw new Error("Organization ID is required");

    return defer({
      companies: queryClient.ensureQueryData(getCompaniesOptions(params.organizationId)),
    });
  };
